import { Bruker, EnkelBruker, PaginatedHistoryResult, PaginatedResult, TilgangsgruppeMedlemskap } from '../../../models';
import RequestService, { getQueryURL } from '../requestService';
import { client } from '../../client';
import { FilterQueries } from '../../../app/utils/filter';
import { PageParam } from '../../rtk-queries/queryApiCreator';
import { tEntityId } from '../../../models/entity';
import { KodeHistorikk } from '../../../models/kodeHistorikk';

export type BrukerTilgangsgrupperMedlemerArgs = { id: string, q?: string; disablePagination?: boolean, alle: boolean, kunGenerelle?: boolean, kunAktive?: boolean };


export default class BrukerService extends RequestService<Bruker, 'bruker'> {
    // enkelBruker = async (searchString: string, filter?: FilterQueries) =>
    //     client.get<EnkelBruker[]>(getQueryURL(`${this.serviceName}/enkel_brukere/filter`, {
    //         q: searchString
    //     }));
        enkelBruker = async (searchString: string, filter?: FilterQueries) =>
            client.get<EnkelBruker[]>(getQueryURL(`${this.serviceName}/enkel_brukere_med_organ/filter`, {
                q: searchString
            }));
    mainBruker = async (searchString: string) => client.get<EnkelBruker[]>(getQueryURL(`${this.serviceName}/main_brukere`, {
        q: searchString
    }));
    hentAktiv = async () => client.get<Bruker>(`${this.serviceName}/aktiv`);
    hentKodeHistorikk = async (searchString: string) => client.get<PaginatedResult<KodeHistorikk>>(`${this.serviceName}/hentKodehistorikk/${encodeURIComponent(searchString)}`);
    reparerKodehistorikk = async (searchString: string) => client.get<PaginatedResult<KodeHistorikk>>(`${this.serviceName}/reparerKodehistorikk/${encodeURIComponent(searchString)}`);
    sekundarBruker = async (searchString: string) => client.get<PaginatedResult<EnkelBruker>>(getQueryURL(`${this.serviceName}/sekundar_brukere`, {
        q: searchString
    }));
    hentAllEpost = async (searchString: string, kategori: string, disablePagination?: boolean) => client.get<PaginatedResult<EnkelBruker>>(getQueryURL(`${this.serviceName}/hentAllEpost`, {
        kategori,
        q: searchString,
        disablePagination
    }));
    hentAlleBrukereDtoMedKategoriEn = async (searchString: string, disablePagination?: boolean) => client.get<PaginatedResult<EnkelBruker>>(getQueryURL(`${this.serviceName}/hentAlleBrukereDtoMedKategoriEn`, {
        q: searchString,
        disablePagination
    }));

    brukerProfiler = async (searchString: string, disablePagination?: boolean) => client.get<PaginatedResult<EnkelBruker>>(getQueryURL(`${this.serviceName}/brukerProfiler`, {
        q: searchString,
        disablePagination
    }));
    sistInnloggetSomStedfortreder = async (id: number) => client.get<Date>(`${this.serviceName}/sistInnloggetSomStedfortreder/${encodeURIComponent(id)}`);
    hentTilgangsgrupperMedlemerForBruker = async ({ id, ...queryParam }: BrukerTilgangsgrupperMedlemerArgs) =>
        client.get<PaginatedHistoryResult<TilgangsgruppeMedlemskap>>(getQueryURL(`${this.serviceName}/hentTilgangsgrupperMedlemerForBruker/${encodeURIComponent(id)}`, queryParam));
    deaktivereMedlemskap = async (itemId: tEntityId, deaktivertListe: TilgangsgruppeMedlemskap[]) => client.post<void>(`${this.serviceName}/${encodeURIComponent(itemId)}/medlemskap/deaktivere`, deaktivertListe);
}